module.exports = __webpack_public_path__ + "static/media/Jason Oliveira.5d891b6a.png";